// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user--2wtuRwu- {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.username--1TtuAE5b {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"user": "user--2wtuRwu-",
	"username": "username--1TtuAE5b"
};
export default ___CSS_LOADER_EXPORT___;
